import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { formatTime, generateTimes } from "../../../services/helpers";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../Accounts.module.scss";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { useMediaQuery } from "@mui/material";
import AuthContext from "../../../hooks/authContext";
import CommonContext from "../../../hooks/commonContext";
import {
  getSettings,
  resetSettings,
  saveSettings,
  updateSettings,
} from "../../../services/apiservices/settings";
import {
  CommonConfirmationDialog,
  CommonSuccessDialog,
} from "../../../components/DialogComponent/SupplyDataDialog";
import { useNavigate } from "react-router";
import TipsCard, { SettingsSummary } from "./AppointmentTips";
import { CalendarTodayOutlined } from "@mui/icons-material";
import { useToast } from "../../../hooks/useToast";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import { MapPin } from "lucide-react";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  selectinput: {
    padding: "10px 10px",
  },
  selectlabel: {
    transform: "translate(14px, 15px) scale(1)",
  },
  selectoption: {
    margin: 0,
  },
}));

const AppointmentPageSetting = () => {
  const auth = useContext(AuthContext);
  const commonContext = useContext(CommonContext);
  const [schedulingSystem, setSchedulingSystem] = useState("proteams");
  const schedulingSytemsOptions = [
    { label: "Proteams", value: "proteams" },
    // { label: "Acuity", value: "acuity" },
  ];
  const [workWeek, setWorkWeek] = useState([]);
  const isMobile = useMediaQuery("(max-width:767px)");
  // const isLandscape = useMediaQuery(
  //   "(min-width: 771px) and (max-width: 940px)"
  // );
  const timeOptions = generateTimes();
  const [standardWorkTime, setStandardWorkTime] = useState("no");
  const [startTime, setStartTime] = useState("09:00 am");
  const [endTime, setEndTime] = useState("07:00 pm");
  const [timeInterval, setTimeInterval] = useState("30 min");
  const [earlyCheckIn, setEarlyCheckIn] = useState("15 min");
  const [geoFencingStatus, setGeoFencingStatus] = useState("Disabled");
  const [overlapping, setOverlapping] = useState("None");
  const [measurementUnit, setMeasurementUnit] = useState("meters");
  const [geoFencingRadius, setGeoFencingRadius] = useState();
  const [timeFormat, setTimeFormat] = useState("12hrs");
  const [error, setError] = useState({});
  const [data, setData] = useState();
  const [open, setOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [resetOpen, setResetOpen] = useState(false);
  const [resetSuccessOpen, setResetSuccessOpen] = useState(false);
  const navigate = useNavigate();
  const classes = useStyles();
  const { toast } = useToast();

  const [activeTab, setActiveTab] = useState("general");

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
  };

  const defaultWorkWeek = ["monday", "tuesday", "wednesday", "thursday", "friday"];

  const workWeeks = [
    { label: "Monday", value: "monday" },
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
  ];

  const standardWorkTimes = [
    { label: "Yes, allow scheduling outside standard hours", value: "yes" },
    { label: "No, restrict to standard hours only", value: "no" },
  ];

  const Overlapping = [
    { label: "None", value: "None" },
    { label: "Leads / Managers", value: "Leads / Managers" },
    { label: "Team Admin / Support", value: "Team Admin / Support" },
    { label: "All Employees", value: "All Employees" },
  ];

  const timeIntervalOptions = [
    { label: "15 Min", value: "15 min" },
    { label: "30 Min", value: "30 min" },
    { label: "60 Min", value: "60 min" },
  ];

  const earlyCheckInOptions = [
    {
      label: "Not Allowed (check-in only at appointment time)",
      value: "notAllowed",
    },
    { label: "5 Min", value: "5 min" },
    { label: "10 Min", value: "10 min" },
    { label: "15 Min", value: "15 min" },
    { label: "30 Min", value: "30 min" },
  ];

  const FeetOptions = [
      { value: "150ft", label: "150 Feet (very close)" },
      { value: "300ft", label: "300 Feet (close proximity)" },
      { value: "600ft", label: "600 Feet (nearby area)" },
      { value: "900ft", label: "900 Feet (broad area)" },
      { value: "1200ft", label: "1200 Feet (wide area)" },
  ];

  const MetersOptions = [
    { value: "45m", label: "45 meters (very close)" },
    { value: "90m", label: "90 meters (close proximity)" },
    { value: "180m", label: "180 meters (nearby area)" },
    { value: "275m", label: "275 meters (broad area)" },
    { value: "365m", label: "365 meters (wide area)" },
  ];

  const TimeFormatsOptions = [
    { label: "12 Hrs", value: "12hrs" },
    { label: "24 Hrs", value: "24hrs" },
  ];

  const GeoFencingStatusOptions = [
    { label: "Disabled (no location restrictions)", value: "Disabled" },
    { label: "Enabled (require location verification)", value: "Enabled" },
  ];

  const MeasurementUnitOptions = [
    { label: "Meters", value: "meters" },
    { label: "Feet", value: "feet" },
  ];

  const resetAll = () => {
    setData();
    setSchedulingSystem("proteams");
    setWorkWeek(defaultWorkWeek);
    setStartTime("09:00 am");
    setEndTime("07:00 pm");
    setStandardWorkTime("no");
    setTimeInterval("30 min");
    setEarlyCheckIn("15 min");
    setOverlapping("None");
    setTimeFormat("12hrs");
    setGeoFencingStatus("Disabled");
    setMeasurementUnit("meters");
    setGeoFencingRadius();
    setError({});
  };

  const fetchSettings = async () => {
    const companyId =
      auth?.userProfile?.role === "companyUser"
        ? auth?.userProfile?.id
        : auth?.userProfile?.companyId;

    getSettings("appointment_settings", companyId, (res) => {
      if (res?.data) {
        const filteredData = res.data?.filter(
          (item) => !item.deleted
        );
        if (filteredData?.length > 0) {
          const [firstItem] = filteredData;
          setData(filteredData);
          setSchedulingSystem(firstItem?.schedulingSystem);
          setWorkWeek(firstItem?.workWeek?.length  ? firstItem?.workWeek  : defaultWorkWeek);
          setStartTime(formatTime(firstItem?.startTime));
          setEndTime(formatTime(firstItem?.endTime));
          setStandardWorkTime(firstItem?.standardWorkTime);
          setTimeInterval(firstItem?.timeInterval || "30 min");
          setEarlyCheckIn(firstItem?.earlyCheckIn  || "15 min");
          setOverlapping(firstItem?.overlapping || "None");
          setTimeFormat(firstItem?.timeFormat || "12hrs");
          setGeoFencingStatus(firstItem?.geoFencingStatus || "Disabled");
          setMeasurementUnit(firstItem?.measurementUnit);
          setGeoFencingRadius(firstItem?.geoFencingRadius);
        } else {
          resetAll();
        }
      } else {
        resetAll();
      }
    });
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const validFields = () => {
    const errorMessages = {};
    let isValid = true;

    const fields = {
      // schedulingSystem: "Scheduling System is Required",
      // workWeek: "Work Week is Required",
      // startTime: "Start Time is Required",
      // endTime: "End Time is Required",
      // standardWorkTime: "Standard Work Time is Required",
      // timeInterval: "Time Interval is Required",
      // earlyCheckIn: "Early Check-In is Required",
      // timeFormat: "Time Format is Required",
    };

    Object.entries(fields).forEach(([key, errorMessage]) => {
      if (!eval(key) || (key === "workWeek" && !workWeek.length)) {
        isValid = false;
        errorMessages[key] = errorMessage;
      }
    });

    setError(errorMessages);
    return isValid;
  };

  const handelSchedulingSystem = (e) => {
    const system = e;
    setSchedulingSystem(system);
  };

  const handelChangeWorkWeek = (e, value) => {
    if (e.target.checked) {
      setWorkWeek((prev) => [...prev, value]);
    } else {
      setWorkWeek((prev) => prev.filter((day) => day !== value));
    }
  };

  // If user disselect all so then at that time automatically it reset to default 
  // const handelChangeWorkWeek = (e, value) => {
  //   setWorkWeek((prev) => {
  //     let updated;

  //     if (e.target.checked) {
  //       updated = [...prev, value];
  //     } else {
  //       updated = prev.filter((day) => day !== value);
  //     }

  //     if (updated.length === 0) {
  //       updated = ["monday", "tuesday", "wednesday", "thursday", "friday"];
  //     }

  //     return updated;
  //   });
  // };

  const handleSaveData = async () => {
    
    commonContext?.setLoader(true);
    if (!validFields()) {
      commonContext?.setLoader(false);
      return;
    } else {
      
      const companyId =
        auth?.userProfile?.role === "companyUser"
          ? auth?.userProfile?.id
          : auth?.userProfile?.companyId;

      const dataToSave = {
        schedulingSystem: schedulingSystem,
        workWeek: workWeek,
        startTime: startTime,
        endTime: endTime,
        standardWorkTime: standardWorkTime,
        timeInterval: timeInterval,
        earlyCheckIn: earlyCheckIn,
        timeFormat: timeFormat,
        companyId: companyId,
        overlapping: overlapping,
        geoFencingStatus: geoFencingStatus,
        measurementUnit: measurementUnit,
        geoFencingRadius: geoFencingRadius,
      };

      const data = await saveSettings(dataToSave, "appointment_settings");
      
      if (data.status === true) {
        await fetchSettings();
        toast?.({ title: "Success", description: "Setting Saved Successfully" });
        commonContext?.setLoader(false);
      }
      commonContext?.setLoader(false);
    }
  };

  const handleUpdateData = async () => {
    commonContext?.setLoader(true);
    if (!validFields()) {
      commonContext?.setLoader(false);
      return;
    } else {
      const dataToSave = {
        schedulingSystem: schedulingSystem,
        workWeek: workWeek,
        startTime: startTime,
        endTime: endTime,
        standardWorkTime: standardWorkTime,
        timeInterval: timeInterval,
        earlyCheckIn: earlyCheckIn,
        timeFormat: timeFormat,
        overlapping: overlapping,
        geoFencingStatus: geoFencingStatus,
        measurementUnit: measurementUnit,
        geoFencingRadius: geoFencingRadius,
      };
      const id = data[0]?.id;

      const details = await updateSettings(
        dataToSave,
        "appointment_settings",
        id
      );
      if (details.status === true) {
        await fetchSettings();
        toast?.({ title: "Success", description: "Setting Update Successfully" });
        commonContext?.setLoader(false);
      }
      commonContext?.setLoader(false);
    }
  };

  const handleResetConfirm = async () => {
    setResetOpen(false);
    commonContext?.setLoader(true);
    const id = data[0]?.id;
    const details = await resetSettings("appointment_settings", id);
    if (details.status === true) {
      await fetchSettings();
      toast?.({ title: "Success", description: "Setting Reset Successfully" });
      commonContext?.setLoader(false);
    }
    commonContext?.setLoader(false);
  };

  const handleResetClose = () => {
    setResetOpen(false);
  };

  const handleResetSuccessClose = () => {
    setResetSuccessOpen(false);
    fetchSettings();
    toast?.({ title: "Success", description: "Setting Reset Successfully" });
  };

  const handleColse = () => {
    setOpen(false);
    fetchSettings();
    toast?.({ title: "Success", description: "Setting Saved Successfully" });
  };

  const handleUpdateClose = () => {
    setUpdateOpen(false);
    fetchSettings();
    toast?.({ title: "Success", description: "Setting Update Successfully" });
  };

  const handleReset = () => {
    if (data) {
      setResetOpen(true);
    } else {
      resetAll();
    }
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle={`Appointment Settings`}
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Settings", to: "/account/settings" },
          ]}
          BreadCrumbCurrentPageTitle={"Appointment"}
          showLastSeen={true}
        />
        <div
          className={
            isMobile
              ? "sectionBox p-8 dark:bg-[#1A1F2C]"
              : "sectionBox dark:bg-[#1A1F2C]"
          }
        >
          <div className={`${styles.configCard}`}>
            <div
              className={`${styles.configcardHeader} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
            >
              <div className={`${styles.configcardTitle} dark:text-white`}>
                <CalendarTodayOutlined
                  fontSize="small"
                  className={styles.calendarIcon}
                />
                Appointment Configuration
              </div>
              <div className={styles.configcardDescription}>
                Configure how appointments work in your system
              </div>
            </div>

            <div
              className={`${styles.configcardContent} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
            >
              <div className={styles.tabs}>
                <div className={styles.tabsHeader}>
                  <Button
                    className={`${styles.tabTrigger} ${
                      activeTab === "general" ? styles.activeTab : ""
                    }`}
                    onClick={() => handleTabChange("general")}
                  >
                    General
                  </Button>
                  <Button
                    className={`${styles.tabTrigger} ${
                      activeTab === "scheduling" ? styles.activeTab : ""
                    }`}
                    onClick={() => handleTabChange("scheduling")}
                  >
                    Scheduling
                  </Button>
                  <Button
                    className={`${styles.tabTrigger} ${
                      activeTab === "checkin" ? styles.activeTab : ""
                    }`}
                    onClick={() => handleTabChange("checkin")}
                  >
                    Check-in
                  </Button>
                  <Button
                    className={`${styles.tabTrigger} ${
                      activeTab === "geo-Fencing" ? styles.activeTab : ""
                    }`}
                    onClick={() => handleTabChange("geo-Fencing")}
                  >
                    Geo-Fencing
                  </Button>
                </div>
              </div>
              {activeTab === "general" && (
                <div className={styles.tabContent}>
                  <div
                    className={`${
                      isMobile ? "d-flex flex-direction-column" : "d-flex"
                    }`}
                  >
                    <div
                      className={`${
                        isMobile
                          ? "d-flex flex-direction-column mv-30 w-100"
                          : "d-flex flex-direction-column mt-18 w-100"
                      }`}
                    >
                      <div className={`${styles.label} mb-18 dark:text-white`}>
                        Scheduling System
                      </div>
                      <div
                        className={`${
                          isMobile
                            ? `mt-10 ${styles.selectWidth}`
                            : `${styles.selectWidth}`
                        }`}
                      >
                        <SingleSelectNew
                          contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                          itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                          value={schedulingSystem}
                          name={"schedulingSystem"}
                          label={"Scheduling System"}
                          onChange={(e) => handelSchedulingSystem(e)}
                          options={schedulingSytemsOptions}
                        />
                        {error.schedulingSystem && (
                          <span className="d-flex small error color-danger">
                            {error.schedulingSystem}
                          </span>
                        )}
                      </div>
                      <div
                        className={`${styles.label} mt-15 dark:text-white`}
                        style={{ fontSize: "12px" }}
                      >
                        Choose your preferred scheduling system
                      </div>
                    </div>
                    <div
                      className={`${
                        isMobile
                          ? "d-flex flex-direction-column mv-30 w-100"
                          : "d-flex flex-direction-column ml-20 mt-18  w-100"
                      }`}
                    >
                      <div className={`${styles.label} mb-18 dark:text-white`}>
                        {" "}
                        Time Formats{" "}
                      </div>
                      <div
                        className={`${
                          isMobile
                            ? `mt-10 ${styles.selectWidth}`
                            : `${styles.selectWidth}`
                        }`}
                      >
                        <SingleSelectNew
                          contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                          itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                          value={timeFormat}
                          name={"timeFormat"}
                          label={"Time Formats"}
                          onChange={(e) => setTimeFormat(e)}
                          options={TimeFormatsOptions}
                        />
                        {error.timeFormat && (
                          <span className="d-flex small error color-danger">
                            {error.timeFormat}
                          </span>
                        )}
                      </div>
                      <div
                        className={`${styles.label} mt-15`}
                        style={{ fontSize: "12px", color: "#64748B" }}
                      >
                        Display time in 12-hour or 24-hour format
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "scheduling" && (
                <div className={`${styles.tabContent}`}>
                  <div
                    className={`${
                      isMobile ? "d-flex flex-direction-column" : "d-flex"
                    }`}
                  >
                    <div
                      className={`${
                        isMobile
                          ? "d-flex flex-direction-column mv-30 w-100"
                          : "d-flex flex-direction-column mt-18 w-100"
                      }`}
                    >
                      <div className={`${styles.label} mb-18 dark:text-white`}>
                        Work Days
                      </div>

                      <div
                        className={`p-16 br-8 border ${styles.selectBox} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white`}
                      >
                        {workWeeks?.map((day) => (
                          <label
                            key={day.value}
                            className="d-flex flex-center mb-10"
                          >
                            <input
                              type="checkbox"
                              checked={workWeek?.includes(day.value)}
                              onChange={(e) =>
                                handelChangeWorkWeek(e, day.value)
                              }
                              className={`${styles.customCheckbox} mr-8`}
                            />
                            {day.label}
                          </label>
                        ))}
                      </div>

                      {error.workWeek && (
                        <span className="d-flex small error color-danger mt-8">
                          {error.workWeek}
                        </span>
                      )}
                      <div
                        className={`${styles.label} mt-15`}
                        style={{ fontSize: "12px", color: "#64748B" }}
                      >
                        Select days of the week when appointments can be
                        scheduled
                      </div>
                    </div>
                    <div className="d-flex flex-direction-column w-100">
                      <div
                        className={`${
                          isMobile
                            ? "d-flex flex-direction-column mv-30 w-100"
                            : "d-flex flex-direction-column  ml-20 mt-18 w-100"
                        }`}
                      >
                        <div
                          className={`${styles.label} mb-18 dark:text-white`}
                        >
                          {" "}
                          Time Interval{" "}
                        </div>
                        <div
                          className={`${
                            isMobile
                              ? `mt-10 ${styles.selectWidth}`
                              : `${styles.selectWidth}`
                          }`}
                        >
                          <SingleSelectNew
                            contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                            itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                            value={timeInterval}
                            name={"timeinterval"}
                            label={"Time Interval"}
                            onChange={(e) => setTimeInterval(e)}
                            options={timeIntervalOptions}
                          />
                          {error.endTimeInterval && (
                            <span className="d-flex small error color-danger">
                              {error.endTimeInterval}
                            </span>
                          )}
                        </div>
                        <div
                          className={`${styles.label} mt-15`}
                          style={{ fontSize: "12px", color: "#64748B" }}
                        >
                          Time slots for appointment scheduling
                        </div>
                      </div>
                      <div
                        className={`${
                          isMobile
                            ? "d-flex flex-direction-column mv-30 w-100"
                            : "d-flex flex-direction-column ml-20 mt-35 w-100"
                        }`}
                      >
                        <div
                          className={`${styles.label} mb-18 dark:text-white`}
                        >
                          {" "}
                          Work before/after standard times{" "}
                        </div>
                        <div
                          className={`${
                            isMobile
                              ? `mt-10 ${styles.selectWidth}`
                              : `${styles.selectWidth}`
                          }`}
                        >
                          <SingleSelectNew
                            contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                            itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                            value={standardWorkTime}
                            name={"standardworktime"}
                            label={"Work before/after standard times"}
                            onChange={(e) =>
                              setStandardWorkTime(e)
                            }
                            options={standardWorkTimes}
                          />
                          {error.standardWorkTime && (
                            <span className="d-flex small error color-danger">
                              {error.standardWorkTime}
                            </span>
                          )}
                        </div>
                        <div
                          className={`${styles.label} mt-15`}
                          style={{ fontSize: "12px", color: "#64748B" }}
                        >
                          Allow appointments outside of standard business hours
                        </div>
                      </div>
                    </div>
                  </div>
                  
                <div className="d-flex w-100">
                  <div
                    className={`${
                      isMobile ? "d-flex flex-direction-column" : "d-flex flex-direction-column w-100"
                    }`}
                  >
                    <div
                      className={`${
                        isMobile
                          ? "d-flex flex-direction-column mv-30 w-100"
                          : "d-flex flex-direction-column mt-18 w-100"
                      }`}
                    >
                      <div className={`${styles.label} mb-18 dark:text-white`}>
                        Standard Start Time
                      </div>
                      <div
                        className={`${
                          isMobile
                            ? `mt-10 ${styles.selectWidth}`
                            : `${styles.selectWidth}`
                        }`}
                      >
                        <FormControl fullWidth variant="outlined">
                          {/* <InputLabel className={classes.selectlabel}>
                            Standard Start Time
                          </InputLabel> */}
                          <Select
                            value={startTime}
                            onChange={(event) => {
                              setStartTime(event.target.value);
                            }}
                            // label="Standard Start Time"
                             inputProps={{
                              className: `${classes.selectinput} dark:bg-[#0F1729] dark:text-white`,
                            }}
                            MenuProps={{
                              PaperProps: {
                                className: "dark:bg-[#0F1729] dark:text-white",
                              },
                            }}
                          >
                            {timeOptions.map((time, index) => (
                              <MenuItem
                                key={index}
                                value={time}
                                className={`
                                  dark:text-white 
                                  dark:hover:bg-gray-700 
                                  dark:bg-[#0F1729]
                                  ${
                                    startTime === time
                                      ? "dark:bg-gray-600 dark:text-black"
                                      : ""
                                  }`}
                              >
                                {time}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {error.startTime && (
                          <span className="d-flex small error color-danger">
                            {error.startTime}
                          </span>
                        )}
                      </div>
                      <div
                        className={`${styles.label} mt-15`}
                        style={{ fontSize: "12px", color: "#64748B" }}
                      >
                        Default start time for the working day
                      </div>
                    </div>
                    <div
                      className={`${
                        isMobile
                          ? "d-flex flex-direction-column mv-30 w-100"
                          : "d-flex flex-direction-column mt-18 w-100"
                      }`}
                    >
                      <div className={`${styles.label} mb-18 dark:text-white`}>
                        {" "}
                        Standard End Time{" "}
                      </div>
                      <div
                        className={`${
                          isMobile
                            ? `mt-10 ${styles.selectWidth}`
                            : `${styles.selectWidth}`
                        }`}
                      >
                        <FormControl fullWidth variant="outlined">
                          {/* <InputLabel className={classes.selectlabel}>
                            Standard End Time
                          </InputLabel> */}
                          <Select
                            value={endTime}
                            onChange={(event) => {
                              setEndTime(event.target.value);
                            }}
                            // label="Standard End Time"
                            inputProps={{
                              className: `${classes.selectinput} dark:bg-[#0F1729] dark:text-white`,
                            }}
                            MenuProps={{
                              PaperProps: {
                                className: "dark:bg-[#0F1729] dark:text-white",
                              },
                            }}
                          >
                            {timeOptions.map((time, index) => (
                              <MenuItem
                                key={index}
                                value={time}
                                className={`
                                  dark:text-white 
                                  dark:hover:bg-gray-700 
                                  dark:bg-[#0F1729]
                                  ${
                                    endTime === time
                                      ? "dark:bg-gray-600 dark:text-black"
                                      : ""
                                  }`}
                              >
                                {time}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {error.endTime && (
                          <span className="d-flex small error color-danger">
                            {error.endTime}
                          </span>
                        )}
                      </div>
                      <div
                        className={`${styles.label} mt-15`}
                        style={{ fontSize: "12px", color: "#64748B" }}
                      >
                        Default end time for the working day
                      </div>
                    </div>
                  </div>

                    <div
                      className={`${
                          isMobile
                            ? "d-flex flex-direction-column mv-30 w-100"
                            : "d-flex flex-direction-column ml-20 mt-15 w-100"
                        }`}
                      >
                        <div
                          className={`${styles.label} mb-18 dark:text-white`}
                        >
                          {" "}
                          Allow Overlapping Bookings (for employees){" "}
                        </div>
                        <div
                          className={`${
                            isMobile
                              ? `mt-10 ${styles.selectWidth}`
                              : `${styles.selectWidth}`
                          }`}
                        >
                          <SingleSelectNew
                            contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                            itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                            value={overlapping}
                            name={"overlapping"}
                            label={"Overlapping Bookings"}
                            onChange={(e) =>
                              setOverlapping(e)
                            }
                            options={Overlapping}
                          />
                          {error.overlapping && (
                            <span className="d-flex small error color-danger">
                              {error.overlapping}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                </div>
              )}
              {activeTab === "checkin" && (
                <div className={styles.tabContent}>
                  <div
                    className={`${
                      isMobile
                        ? "d-flex flex-direction-column mv-30 w-100"
                        : "d-flex flex-direction-column mt-18 w-100"
                    }`}
                  >
                    <div className={`${styles.label} mb-18 dark:text-white`}>
                      {" "}
                      Early Check In{" "}
                    </div>
                    <div
                      className={`${
                        isMobile ? `mt-10 ${styles.selectWidth}` : `width50`
                      }`}
                    >
                      <SingleSelectNew
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        value={earlyCheckIn}
                        name={"earlyCheckIn"}
                        label={"Early Check In"}
                        onChange={(e) => setEarlyCheckIn(e)}
                        options={earlyCheckInOptions}
                      />
                      {error.earlyCheckIn && (
                        <span className="d-flex small error color-danger">
                          {error.earlyCheckIn}
                        </span>
                      )}
                    </div>
                    <div
                      className={`${styles.label} mt-15`}
                      style={{ fontSize: "12px", color: "#64748B" }}
                    >
                      Allow your employees to check in before their scheduled appointment time
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "geo-Fencing" && (
                <>
                <div className={styles.tabContent}>
                <div className="md:col-span-2 bg-blue-50 border border-blue-200 rounded-lg p-16 mb-8">
                  <div className="flex items-center mb-8">
                    <MapPin className="w-5 h-5 text-blue-600 mr-8" />
                    <h3 className="text-base font-semibold text-blue-900">Geo-Fencing Settings</h3>
                  </div>
                  <p className="text-sm text-blue-700">
                    Configure location-based restrictions for appointment check-ins. When enabled, employees must be within the specified radius of your business address to check in.
                  </p>
                </div>
                <div className={isMobile ? "d-flex flex-direction-column" : "d-flex"}>
                  <div
                    className={`${
                      isMobile
                        ? "d-flex flex-direction-column mv-30 w-100"
                        : "d-flex flex-direction-column mt-18 mr-15 w-100"
                    }`}
                  >
                    <div className={`${styles.label} mb-18 dark:text-white`}>
                      {" "}
                      Geo-Fencing Status{" "}
                    </div>
                    <div
                      className={`${
                        isMobile ? `mt-10 ${styles.selectWidth}` : ``
                      }`}
                    >
                      <SingleSelectNew
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        value={geoFencingStatus}
                        name={"geoFencingStatus"}
                        label={"Geo-Fencing Status"}
                        onChange={(e) => setGeoFencingStatus(e)}
                        options={GeoFencingStatusOptions}
                      />
                      {error?.geoFencingStatus && (
                        <span className="d-flex small error color-danger">
                          {error?.geoFencingStatus}
                        </span>
                      )}
                    </div>
                    <div
                      className={`${styles.label} mt-15`}
                      style={{ fontSize: "12px", color: "#64748B" }}
                    >
                     Enable or disable location-based check-in restrictions
                    </div>
                  </div>
                  {geoFencingStatus === "Enabled" && (
                  <div
                    className={`${
                      isMobile
                        ? "d-flex flex-direction-column mv-30 w-100"
                        : "d-flex flex-direction-column mt-18 ml-15 w-100"
                    }`}
                  >
                    <div className={`${styles.label} mb-18 dark:text-white`}>
                      {" "}
                      Measurement Unit{" "}
                    </div>
                    <div
                      className={`${
                        isMobile ? `mt-10 ${styles.selectWidth}` : ``
                      }`}
                    >
                      <SingleSelectNew
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        value={measurementUnit}
                        name={"measurementUnit"}
                        label={"Measurement Unit"}
                        onChange={(e) => setMeasurementUnit(e)}
                        options={MeasurementUnitOptions}
                      />
                      {error?.measurementUnit && (
                        <span className="d-flex small error color-danger">
                          {error?.measurementUnit}
                        </span>
                      )}
                    </div>
                    <div
                      className={`${styles.label} mt-15`}
                      style={{ fontSize: "12px", color: "#64748B" }}
                    >
                     Choose your preferred unit of measurement for radius distances
                    </div>
                  </div>
                  )}
                  </div>
                 {geoFencingStatus === "Enabled" && (
                  <div
                    className={`${
                      isMobile
                        ? "d-flex flex-direction-column mv-30 w-100"
                        : "d-flex flex-direction-column mt-18 w-100"
                    }`}
                  >
                    <div className={`${styles.label} mb-18 dark:text-white`}>
                      {" "}
                      Geo-Fencing Radius{" "}
                    </div>
                    <div
                      className={`${
                        isMobile ? `mt-10 ${styles.selectWidth}` : `width50`
                      }`}
                    >
                      <SingleSelectNew
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        value={geoFencingRadius}
                        name={"geoFencingRadius"}
                        label={"Geo-Fencing Radius"}
                        onChange={(e) => setGeoFencingRadius(e)}
                        options={measurementUnit === "feet" ? FeetOptions : MetersOptions}
                      />
                      {error?.geoFencingRadius && (
                        <span className="d-flex small error color-danger">
                          {error?.geoFencingRadius}
                        </span>
                      )}
                    </div>
                    <div
                      className={`${styles.label} mt-15`}
                      style={{ fontSize: "12px", color: "#64748B" }}
                    >
                     Enable or disable location-based check-in restrictions
                    </div>
                  </div>
                  )}
                  {geoFencingStatus === "Enabled" && (
                    <div className="md:col-span-2 bg-amber-50 border border-amber-200 rounded-lg p-16 mt-12">
                      <div className="flex items-start">
                        <div className="flex-shrink-0">
                          <MapPin className="w-5 h-5 text-amber-600 mt-2" />
                        </div>
                        <div className="ml-12">
                          <h4 className="text-sm font-medium text-amber-800 mb-4">Important Notes</h4>
                          <ul className="text-xs text-amber-700 space-y-1">
                            <li>• Employees will need to enable location services on their device</li>
                            <li>• GPS accuracy may vary based on device and environmental conditions</li>
                            <li>• Consider a larger radius for areas with poor GPS signal</li>
                            <li>• Some employees may need assistance if they're having location issues</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                </>
              )}
              <div
                className={
                  isMobile
                    ? `${styles.formFooter} d-flex flex-justify-center dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`
                    : `${styles.formFooter} d-flex flex-justify-flexend dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`
                }
              >
                <Button
                  variant="outlined"
                  className="dark:text-white"
                  style={{
                    boxShadow: "none",
                    padding: isMobile ? "5px 8px" : "",
                  }}
                  onClick={() => navigate("/account/settings")}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  style={{
                    marginLeft: 10,
                    boxShadow: "none",
                    padding: isMobile ? "5px 8px" : "",
                  }}
                  onClick={handleReset}
                >
                  Reset to Defaults
                </Button>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#078037",
                    color: "white",
                    marginLeft: 10,
                    boxShadow: "none",
                    padding: isMobile ? "5px 8px" : "",
                  }}
                  onClick={data ? handleUpdateData : handleSaveData}
                >
                  {data ? "Update Changes" : "Save Changes"}
                </Button>
              </div>
            </div>
          </div>

          <SettingsSummary
            schedulingSystem={schedulingSystem}
            workWeek={workWeek}
            startTime={startTime}
            endTime={endTime}
            overlapping={overlapping}
            timeFormat={timeFormat}
            earlyCheckIn={earlyCheckIn}
            timeInterval={timeInterval}
            standardWorkTime={standardWorkTime}
            geoFencingStatus={geoFencingStatus}
            measurementUnit={measurementUnit}
            geoFencingRadius={geoFencingRadius}
          />

          <TipsCard />
        </div>
      </Container>

      {open && (
        <CommonSuccessDialog
          open={open}
          onClose={handleColse}
          title={"Success"}
          message={"Your settings have been successfully saved."}
        />
      )}
      {updateOpen && (
        <CommonSuccessDialog
          open={updateOpen}
          onClose={handleUpdateClose}
          title={"Success"}
          message={"Your settings have been successfully update."}
        />
      )}
      {resetOpen && (
        <CommonConfirmationDialog
          open={resetOpen}
          onConfirm={handleResetConfirm}
          onClose={handleResetClose}
          title={"Setting Reset"}
          message={"Are you sure you want to reset the settings?"}
          buttonTitle={"Yes"}
        />
      )}
      {resetSuccessOpen && (
        <CommonSuccessDialog
          open={resetSuccessOpen}
          onClose={handleResetSuccessClose}
          title={"Success"}
          message={"Your settings have been successfully reset."}
        />
      )}
    </>
  );
};

export default AppointmentPageSetting;